@if (isLoading()) {
  <!-- Loading State -->
  <div class="loading-state">
    <app-loader></app-loader>
    <p>Loading your documents...</p>
  </div>

} @else if (forms().length === 0) {
  <!-- Empty State -->
  <div class="empty-state">
    <mat-icon>folder_open</mat-icon>
    <p>No documents found.</p>
  </div>

} @else {
  <!-- Data Loaded -->
  @if (termsForm()) {
    <div class="sales-dashboard-counter">
      <mat-card>
        <mat-card-content>
          <div class="form-card">
            <h3>
              <i class="fa-solid fa-file-pdf" style="opacity: 0.9; color: #028da8;"></i>
              Sales Terms Agreement Form
            </h3>

            <div class="status">
              <div class="label">Status</div>
              <div class="status-text">
                <i class="fa-solid {{ termsForm()?.formStatus === 'Approved' ? 'fa-check' : 'fa-hourglass-half'}}"
                   [class.primary-green]="termsForm()?.formStatus === 'Approved'">
                </i>
                {{ termsForm()?.formStatus }}
              </div>
            </div>

            <a mat-raised-button color="primary" [href]="termsForm()?.formUrl" target="_blank">
              <mat-icon>download</mat-icon> View Document
            </a>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }

  <!-- Referral Forms (uncomment when ready) -->
  <!-- @if (referralForms().length > 0) {
    <h3>Referral Forms</h3>
    @for (form of referralForms(); track form.id) { ... }
  } -->

  <!-- Listing Forms (uncomment when ready) -->
  <!-- @if (listingForms().length > 0) {
    <h3>Listing Forms</h3>
    @for (form of listingForms(); track form.id) { ... }
  } -->
}